import {object, string} from 'yup'

const prependHttpIfMissing = (currentValue) => {
    if (!currentValue) return currentValue
    const doesNotStartWithHttp = !(
        currentValue.startsWith('http://') ||
        currentValue.startsWith('https://')
    )
    return doesNotStartWithHttp ? `http://${currentValue}` : currentValue
}

export const publicationSchema = object({
    link: string().transform(prependHttpIfMissing).url('invalidUrl'),
})

export const publicationFolderSchema = object({
    excelUrl: string()
        .nullable()
        .notRequired()
        .transform(prependHttpIfMissing)
        .test('excelUrl', 'invalidUrl', (value) => {
            if (!value || String(value).trim() === '') return true
            try {
                const parsed = new URL(value)
                return Boolean(parsed)
            } catch {
                return false
            }
        }),
})
